import { useInputState } from 'utils/hooks';
import Options from 'components/Options';
import Simulator from 'components/Simulator';
import PerkList from 'components/PerkList';
import Instructions from 'components/Instructions';
import './main.scss';
import { ResultProvider } from 'contexts/results';
import { GameStateProvider } from 'contexts/gameState';

enum Views {
  INSTRUCTIONS = 'INSTRUCTIONS',
  OPTIONS = 'OPTIONS',
  PERKS = 'PERKS',
  SIMULATOR = 'SIMULATOR',
}

const Main = () => {
  const [view, setView] = useInputState(Views.INSTRUCTIONS, 'view');

  return (
    <ResultProvider>
      <GameStateProvider>
        <div id='main'>
          <div id='main-controls'>
            <button
              type='button'
              onClick={setView}
              value={Views.INSTRUCTIONS}
              disabled={view === Views.INSTRUCTIONS}
            >
              Instructions
            </button>
            <button
              type='button'
              onClick={setView}
              value={Views.OPTIONS}
              disabled={view === Views.OPTIONS}
            >
              Options
            </button>
            <button
              type='button'
              onClick={setView}
              value={Views.PERKS}
              disabled={view === Views.PERKS}
            >
              Perks
            </button>
            <button
              type='button'
              onClick={setView}
              value={Views.SIMULATOR}
              disabled={view === Views.SIMULATOR}
            >
              Simulator
            </button>
          </div>
          {view === Views.INSTRUCTIONS && <Instructions />}
          {view === Views.OPTIONS && <Options />}
          {view === Views.PERKS && <PerkList />}
          {view === Views.SIMULATOR && <Simulator />}
        </div>
      </GameStateProvider>
    </ResultProvider>
  );
};

export default Main;
